import { Dispatch } from "redux";
import { Category, SubCategory } from "../types/categoryTypes";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../../firebase";
import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
} from "../../utils";

export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

export const fetchCategoriesRequest = () => ({
  type: FETCH_CATEGORIES_REQUEST,
});

export const fetchCategoriesSuccess = (categoryPageData: {
  categories: Category[];
}) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: categoryPageData,
});

export const fetchCategoriesFailure = (error: string) => ({
  type: FETCH_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchCategories = () => async (dispatch: Dispatch) => {
  dispatch(fetchCategoriesRequest());

  try {
    let categoriesData: { categories: Category[] } = {
      categories: [],
    };

    // Get categories data from local storage
    const data = getLocalStorageWithExpiry("categoriesList");
    if (data) {
      categoriesData = data;
    } else {
      // Use a single batched request to fetch both categories and subcategories
      const categoriesQuery = query(collection(db, "product_categories"));
      const subcategoriesQuery = query(
        collection(db, "product_sub_categories")
      );
      const [categoriesSnapshot, subcategoriesSnapshot] = await Promise.all([
        getDocs(categoriesQuery),
        getDocs(subcategoriesQuery),
      ]);

      const categoriesItems = categoriesSnapshot.docs.map(
        (doc) => ({ id: doc.id, ...doc.data() } as Category)
      );
      const subcategoriesData = subcategoriesSnapshot.docs.map(
        (doc) => ({ id: doc.id, ...doc.data() } as SubCategory)
      );

      // Associate subcategories with their respective categories
      const categoriesWithSubcategories = categoriesItems.map((category) => ({
        ...category,
        subcategories: subcategoriesData.filter(
          (subcategory) => subcategory.product_category === category.serial
        ),
      }));

      const addedCategories = [
        {
          id: "1",
          name: "Latest Toys",
          slug: "latest-toys",
          serial: "",
          documentId: "1",
        },
        {
          id: "2",
          name: "Popular Toys",
          slug: "popular-toys",
          serial: "",
          documentId: "2",
        },
        {
          id: "3",
          name: "Toys Under $10",
          slug: "toys-under-10",
          serial: "",
          documentId: "3",
        },
        {
          id: "4",
          name: "Toys Under $25",
          slug: "toys-under-25",
          serial: "",
          documentId: "4",
        },
        {
          id: "5",
          name: "Gender Neutral",
          slug: "gender-neutral",
          serial: "",
          documentId: "5",
        },
        ...categoriesWithSubcategories,
      ];

      categoriesData.categories = addedCategories.sort((a, b) =>
        a.name === "Miscellaneous" ? 1 : b.name === "Miscellaneous" ? -1 : 0
      );

      setLocalStorageWithExpiry("categoriesList", categoriesData, 30);
    }
    dispatch(fetchCategoriesSuccess(categoriesData));
  } catch (error) {
    console.error(error);
    dispatch(fetchCategoriesFailure("Error fetching items."));
  }
};
